import { useTranslation } from 'react-i18next'
import './ListItem.css'

interface ListItemProps {
    title: string,
    onClick: () => void,
}

export const ListItem = ({title, onClick}:ListItemProps) => {
    
    return (
        <div className="list_item_container" onClick={onClick}>
            <span className="list_item_title">{title}</span>
        </div>
    )
}